<div #dialog>
  <nb-card>
    <nb-card-header>{{ this.title | translate }}</nb-card-header>
    <nb-card-body>{{ this.subtitle }}</nb-card-body>
    <nb-card-footer>
      @if (!info) {
        <button nbButton (click)="this.cancel()">{{ notitle | translate }}</button>
      }
      <button nbButton (click)="this.submit()" [status]="status">{{ (info ? 'close' : yestitle) | translate }}</button>
    </nb-card-footer>
  </nb-card>
</div>
